import styled from "styled-components";
import { colors } from "../../utils";
import { device } from "../../utils/device";

export const Container = styled.div`
  min-width: 20vw;
  width: 100%;
  border-radius: 8px;
  padding: 16px;
  background-color: white;
  margin-bottom: 20px;
  z-index: 10;
`;

export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const Profile = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const ProfileImage = styled.img`
  width: 40px;
  height: 40px;
`;

export const ProfileName = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Actions = styled.div`
  margin-left: 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (${device.mobileLandscape}) {
    display: none;
  }
`;

export const Button = styled.div`
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid ${colors.purple};
  background-color: ${(props) => (props.primary ? colors.purple : "white")};
  color: ${(props) => (props.primary ? "white" : "black")};
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: ${(props) => (props.primary ? "0" : "8px")};
`;

export const ButtonText = styled.p`
  font-size: 12px;
  text-align: center;
  font-family: "DM Sans";
  font-weight: 400;
  margin: 0px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Stats = styled.div`
  min-width: 295px;
  min-height: 40px;
  width: 22vw;
  height: 6vh;
  display: flex;
  margin-top: 14px;
  align-items: center;
  justify-content: center;

  @media (${device.mobileLandscape}) {
    display: none;
  }
`;

export const Stat = styled.div`
  min-width: 100px;
  min-height: 36px;
  height: 8vh;
  width: 7vw;
  display: flex;
  justify-content: center;
  text-align: center;
`;

export const StatText = styled.span`
  font-family: "DM Sans";
  font-size: ${(props) => (props.primary ? "16px" : "14px")};
  font-weight: ${(props) => (props.primary ? "500" : "400")};
  line-height: 20px;
`;

export const Divider = styled.div`
  min-height: 36px;
  height: 8vh;
  min-width: 1px;
  background-color: #d7e2f1;
`;
